var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99987 2.74804L7.28287 2.01104C5.59988 0.281048 2.51389 0.878046 1.39989 3.05304C0.876892 4.07604 0.758893 5.55303 1.71389 7.43802C2.63389 9.25302 4.54788 11.427 7.99987 13.795C11.4519 11.427 13.3649 9.25302 14.2858 7.43802C15.2408 5.55203 15.1238 4.07604 14.5998 3.05304C13.4859 0.878046 10.3999 0.280048 8.71687 2.01004L7.99987 2.74804ZM7.99987 15C-7.33308 4.86803 3.27888 -3.03994 7.82387 1.14304C7.88387 1.19804 7.94287 1.25504 7.99987 1.31404C8.05629 1.2551 8.115 1.19839 8.17587 1.14404C12.7199 -3.04194 23.3328 4.86703 7.99987 15Z",
    fill: "var(--klothed-tile-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDefault);
export default __webpack_public_path__ + "static/media/heartDefault.731b89867ff77d53377a521ef118fad9.svg";
export { ForwardRef as ReactComponent };